import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import App from './App';
import AllContext from './context/AllContext';
import 'react-modal-video/scss/modal-video.scss';
import './index.scss';
import './tailwind.css';

// gsap is a shared singleton across every component that imports it, so exposing
// this reference lets scripts/prerender.js call ScrollTrigger.getAll()...kill()
// to reverse pin-spacer DOM injection before capturing static HTML — otherwise
// that structural mismatch trips React 18's stricter hydration on a fresh load.
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

const rootElement = document.getElementById('root');
const app = (
  <React.Fragment>
    <AllContext>
      <App />
    </AllContext>
  </React.Fragment>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}


